import React from "react";
import Stat from "../Settlements/Stat";
import "../Settlements/settlements.css";
import "./orderReportTiles.css";
import { orderReportTiles } from "./orderReportSummary";

export default function OrderReportTiles({ summary, basis }) {
  if (!summary) return null;
  return (
    <section className="stl order-report-tiles" aria-label="Order report totals">
      <div className="stl-stats">
        {orderReportTiles(summary, basis).map((tile) => (
          <Stat key={tile.label} label={tile.label} value={tile.value} hint={tile.hint} tone={tile.tone} />
        ))}
      </div>
    </section>
  );
}
